import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { RequestStatus } from "@/shared/api/types";

const STATUS_COLOR: Record<RequestStatus, string> = {
	PENDING: "blue",
	APPROVED: "green",
	DECLINED: "red",
	REOPENED: "orange",
};

type StatusBadgeProps = {
	status: RequestStatus;
};

export function StatusBadge({ status }: StatusBadgeProps) {
	const { t } = useTranslation();
	return (
		<Badge color={STATUS_COLOR[status]} variant="light" radius="sm" tt="none">
			{t(`status.${status}`)}
		</Badge>
	);
}
